import React from "react";

import Icon from "@ant-design/icons";

import { ReactComponent as APIDocsIcon } from "./icon.svg";

export const APIDocsOutlined: React.FC = (props) => <Icon component={APIDocsIcon} {...props} />;
